import { Reveal, Eyebrow } from "@/components/Reveal";

const women = [
  "The woman who creates.",
  "The woman who receives.",
  "The woman who finishes.",
  "The woman who loves deeply.",
  "The woman who makes money.",
  "The woman who plays.",
  "The woman who mothers.",
  "The woman who desires.",
  "The woman who doesn’t postpone being alive until she’s accomplished enough.",
];

export const IdentitySection = () => (
  <section data-testid="identity-section" className="mx-auto max-w-4xl px-5 py-24 text-center sm:py-32">
    <Reveal>
      <Eyebrow>THE WOMAN YOU KEEP IMAGINING</Eyebrow>
      <h2 className="mt-6 text-3xl font-extrabold leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl">
        SHE’S NOT YOUR
        <br />
        FUTURE SELF.
      </h2>
      <p className="mt-4 font-serif text-3xl italic leading-snug text-lime sm:text-5xl">
        SHE’S YOU — FULLY CHOSEN.
      </p>
    </Reveal>

    <div className="mt-14 space-y-3" data-testid="identity-list">
      {women.map((w, i) => (
        <Reveal key={w} delay={Math.min(i * 0.05, 0.35)}>
          <p className="font-serif text-xl italic text-cream/75 sm:text-2xl">{w}</p>
        </Reveal>
      ))}
    </div>

    <Reveal className="mt-16">
      <p className="text-3xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl">
        YOU DON’T CHASE HER.
      </p>
      <p className="mt-3 font-serif text-3xl italic text-lime sm:text-5xl">YOU PRACTICE BEING HER.</p>
    </Reveal>
  </section>
);
